export const msalConfig = {
	auth: {
		clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
		authority: import.meta.env.VITE_MSAL_AUTHORITY,
		redirectUri: '/',
		postLogoutRedirectUri: '/login',
		navigateToLoginRequestUrl: true,
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false,
	},
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
	scopes: [],
};
